import { StateCreator } from 'zustand';

import {
  handleAddNotification,
  handleClearNotifications,
  handleGetLatestUnreadBanner,
  handleMarkAllAsRead,
  handleMarkAsRead,
  handleRemoveNotification,
  handleSetNotifications,
  handleSetReadNotifications,
  handleUpdateNotification,
} from './handlers';
import { NotificationsStore } from './types';

export const createNotificationsSlice: StateCreator<NotificationsStore> = (
  set,
  get,
) => {
  return {
    notifications: [],
    readNotifications: [],
    isInitialLoading: true,
    hasLoadedReadTab: false,
    isReadTabLoading: false,
    setIsInitialLoading: (loading) => set({ isInitialLoading: loading }),
    setHasLoadedReadTab: (value) => set({ hasLoadedReadTab: value }),
    setIsReadTabLoading: (loading) => set({ isReadTabLoading: loading }),
    addNotification: (notification) =>
      handleAddNotification(set, get, notification),
    updateNotification: (notification) =>
      handleUpdateNotification(set, get, notification),
    removeNotification: (id) => handleRemoveNotification(set, get, id),
    markAsRead: (id) => handleMarkAsRead(set, get, id),
    markAllAsRead: (ids) => handleMarkAllAsRead(set, get, ids),
    getLatestUnreadBanner: () => handleGetLatestUnreadBanner(get),
    clearNotifications: () => handleClearNotifications(set),
    setNotifications: (notifications) =>
      handleSetNotifications(set, notifications),
    setReadNotifications: (notifications) =>
      handleSetReadNotifications(set, notifications),
  };
};
